import React from 'react'

import Chart from 'pared/charts'
import Spin from 'pared/components/basicUi/spin'

import ChartContainer from './ChartContainer'
import { IPerformanceChartFragmentType } from './gqls/performanceChart'
import usePerformanceChartConfig from './hooks/usePerformanceChartConfig'

interface IPropsType {
  listLocationGroupMenuItemsRecords: IPerformanceChartFragmentType[]
  loading: boolean
}

const PerformanceChart = ({
  listLocationGroupMenuItemsRecords,
  loading,
}: IPropsType) => {
  const performanceChartConfig = usePerformanceChartConfig(
    listLocationGroupMenuItemsRecords,
  )

  return (
    <ChartContainer>
      <Spin spinning={loading}>
        <Chart {...performanceChartConfig} width={1100} height={750} />
      </Spin>
    </ChartContainer>
  )
}

export default React.memo(
  PerformanceChart,
) as unknown as typeof PerformanceChart
